// ref: https://gitlab.com/atma_inc/tasukeru-today-front/-/issues/101
// https://qiita.com/tonkotsuboy_com/items/5c703c601de6179e3ce1

const ua = navigator.userAgent.toLowerCase()

// ブラウザがsafariかどうかを判定
// 判定条件: useragentの中にsafariは存在し、chromeは存在しない
// 参考: https://developer.mozilla.org/ja/docs/Web/HTTP/Browser_detection_using_the_user_agent
export const isSafari = ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1

export const onTouchStartIsAvailable = typeof document.ontouchstart !== 'undefined' 

// iOSの判定
// 参考: https://qiita.com/zprodev/items/7e133e801e88ae966dc5#ipados%E3%81%AF%E3%83%87%E3%83%95%E3%82%A9%E3%83%AB%E3%83%88%E3%81%AEuseragent%E3%81%8Cmacos%E3%81%A8%E5%90%8C%E3%81%98%E3%81%AB%E3%81%AA%E3%82%8B
export const isIOS = isSafari && onTouchStartIsAvailable

// const isAndroid = () => {
//   return /android/i.test(ua) && window.innerWidth <= 800
// }
// console.log('isAndroid', isAndroid())

export const isPWA = window.matchMedia('(display-mode: standalone)').matches